export const toastTimeoutTime = 10000;

export const poweredByHiver = 'kb-website-powered-by-hiver';

export const customizeNavigationButton = 'ftr-kb-customize-navigation-button';
export const FTR_KB_FOR_OUTLOOK = 'ftr-kb-for-outlook';

export const PRODUCT_KB_ORIGIN = 'https://help.hiverhq.com';
